import { c as _c } from "react/compiler-runtime";
// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================
import { useQuery } from '@tanstack/react-query';
import { createUrlFromPattern } from '@cntxt/domains/access-control';
import { axiosFetch } from '@cntxt/shared/infrastructure/api/http';
import { APIReturnType } from '@cntxt/shared/infrastructure/api/routing';
import { API_BASE } from '../../../shared/constants';
import { getTenantNameByHostname as APIHandler, EndpointParams } from '../api/getTenantNameByHostname';
import { tenantKeys } from './keys';
const network = (params: Awaited<EndpointParams['params']>, {
  signal
}: {
  signal?: AbortSignal;
} = {}): APIReturnType<typeof APIHandler, EndpointParams> => {
  const apiUrl = createUrlFromPattern(`${API_BASE}tenants/hostname/:hostname/name`, params);
  return axiosFetch({
    apiUrl,
    method: 'GET',
    signal
  });
};
export const useGetTenantNameByHostnameQuery = t0 => {
  const $ = _c(8);
  const {
    hostname
  } = t0;
  let t1;
  if ($[0] !== hostname) {
    t1 = tenantKeys.hostname({
      hostname
    });
    $[0] = hostname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hostname) {
    t2 = () => network({
      hostname
    });
    $[2] = hostname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !!hostname;
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
};